import { getAxiosInstance } from '../client';
/** Typed API functions for the registration intent */
export const registrationIntentQueries = {
    /** GET /registration-intent — what the Account registered for, by its token alone (#1833). */
    get: () => getAxiosInstance()
        .get('/registration-intent')
        .then((r) => r.data),
};
/** Query keys for the registration intent - use with TanStack Query */
export const registrationIntentKeys = {
    all: () => ['registration-intent'],
};
//# sourceMappingURL=registration-intent.queries.js.map